import { Component } from 'react';
import { UniGrid } from '../UniGrid';
import { ButtonItem, SimpleItem } from 'devextreme-react/form';
import Uploader from '../Uploader';
import { Button } from 'devextreme-react';
import PrepareAuxFile, { AuxFile } from './AuxFile';
import SideDivider from '../layout/SideDivider';
import ViewDocuments from './ViewDocuments';

class Missions extends Component {

    state = {
        focusedMission: null,
        focusedRowEnabled: true,
        viewDocumentsKey: 1,
        grdKey: 1,
    }

    onMissionSavedOrCanceled = (act, row) => {
        if (act == 'add') {
            this.state.focusedMission = row;
            this.state.grdKey++;
        }

        AuxFile.manageTemporaries('Mission', act, this.state.focusedMission?.id);
        this.setState({ viewDocumentsKey: this.state.viewDocumentsKey + 1 })
    }

    componentDidMount() {
    }

    render() {
        let width = this.props.width ?? (SideDivider.bodyWidth * 0.95) + 'px';

        return (
            <>
                <UniGrid table='mission' dynaLoad width={width} title='مأموریت ها'
                    key={'grd_' + this.state.grdKey}
                    //onDataLoaded={(_rows, cols) => console.log(cols)}
                    popupHeight='auto'
                    onFocusedRowChanged={focusedMission => this.setState({ focusedMission })}
                    focusedRow={this.state.focusedMission}
                    onEditCanceled={() => this.onMissionSavedOrCanceled('remove')}
                    onSaved={(crud, row) => this.onMissionSavedOrCanceled(crud == 'insert' ? 'add' : 'keep', row)}
                    //onEditingStart={e => console.log('started ', e)}

                    // customColumns={[
                    //     {
                    //         name: 'auxFiles',
                    //         caption: 'اسناد ضمیمه',
                    //         width: '6rem',
                    //         cellRender: c => (
                    //             <Button text='...' width='100%' height='100%' stylingMode='text'
                    //                 onClick={() => this.setState({ viewDocumentsKey: (this.state.viewDocumentsKey ?? 0) + 1 })}
                    //             />
                    //         ),
                    //     }
                    // ]}

                    editingForm_ExtraItems={[
                        <SimpleItem colSpan={4}>
                            <PrepareAuxFile table='Mission' rowId={this.state.focusedMission?.id} />
                        </SimpleItem>
                    ]}
                />

                <ViewDocuments table='mission' rowId={this.state.focusedMission?.id} width={width}
                    key={`view_doc_${this.state.focusedMission?.id ?? 0}_${this.state.viewDocumentsKey ?? 0}`}
                />
            </>
        );
    }
}

export default Missions;